module.exports = __webpack_public_path__ + "img/u4.5c61e51f.jpg";